import * as React from "react";
import { CheckIcon, ClipboardIcon } from "lucide-react";

import { cn } from "@/utils/shadcn";
import { Button, ButtonProps } from "@/components/shadcn/button";
import {useTranslation} from "react-i18next";

interface CopyButtonProps extends ButtonProps {
  value: string;
  src?: string;
  event?: any;
}

export async function copyToClipboardWithMeta(value: string, event?: any) {
  navigator.clipboard.writeText(value);
}

export function CopyButton({
  value,
  className,
  src,
  variant = "default",
  event,
  ...props
}: CopyButtonProps) {
  const {t} = useTranslation();
  const [hasCopied, setHasCopied] = React.useState(false);

  React.useEffect(() => {
    setTimeout(() => {
      setHasCopied(false);
    }, 2000);
  }, [hasCopied]);

  return (
    <Button
      variant={variant}
      className={cn(
        "relative z-10 [&_svg]:h-4 [&_svg]:w-4",
        className,
      )}
      onClick={(e: any) => {
        e.preventDefault();
        e.stopPropagation();
        copyToClipboardWithMeta(
          value,
          event
            ? {
              name: event,
              properties: {
                code: value,
              },
            }
            : undefined,
        );
        setHasCopied(true);
      }}
      {...props}
    >
      {hasCopied ? <CheckIcon/> : <ClipboardIcon/>}
      <div className="">{hasCopied ? t("copied") : t("copy")}</div>
    </Button>
  );
}
